import { render, staticRenderFns } from "./TSiteDynamicdns.vue?vue&type=template&id=609f93ee&"
import script from "./TSiteDynamicdns.vue?vue&type=script&lang=js&"
export * from "./TSiteDynamicdns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports